module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customerUserList"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('center', [(_vm.customersLoaded == false) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.customersLoaded == true && _vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncFilterUsers
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.customersLoaded == true && _vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncFilterUsers
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1)]), _vm._v(" "), (_vm.customersLoaded == true) ? _c('v-data-table', {
    ref: "customerTable",
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.headers,
      "id": "hello",
      "items": _vm.filteredUsers,
      "item-key": "id",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(props.expanded == true) ? _c('td', {
          attrs: {
            "width": "70%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(_vm.fncCompanyName(props.item)))]) : _c('td', {
          attrs: {
            "width": "70%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(_vm.fncCompanyName(props.item)))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewCompany(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("account_box")])]), _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewCompanyUsers(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("list")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditCompany(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e()])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-data-table', {
          staticClass: "elevation-1 subTable1 minTable",
          attrs: {
            "headers": _vm.headersSub,
            "items": props.item.branch,
            "hide-actions": "",
            "disable-initial-sort": "",
            "rows-per-page-items": [20, 40, 60, 80, 100]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [_c('td', {
                attrs: {
                  "width": "30%"
                }
              }, [_vm._v(_vm._s(props.item.label.replace(/"/g, '')))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "25%"
                },
                domProps: {
                  "innerHTML": _vm._s(_vm.fncStoreAccount(props.item))
                }
              }), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "10%"
                }
              }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "20%"
                }
              }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "10%"
                }
              }, [_c('v-menu', {
                attrs: {
                  "offset-y": ""
                }
              }, [_c('v-toolbar-side-icon', {
                attrs: {
                  "slot": "activator"
                },
                slot: "activator"
              }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncLinkUsers(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditPricelist(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link User Pricelists")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditPassword(props.item.id, props.item.email)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncViewUser(props.item.id, props.item.region)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
                attrs: {
                  "width": "5%"
                }
              }, [_c('a', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditUser(props.item)
                  }
                }
              }, [_c('i', {
                staticClass: "material-icons"
              }, [_vm._v("edit")])])]) : _vm._e()])]
            }
          }], null, true)
        })]
      }
    }], null, false, 910379182)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}